export enum HttpStatusCode {
    NOT_FOUND = 404,
}
